interface OverlayBackgroundProps {
  children: React.ReactNode
}

export default function OverlayBackground({ children }: OverlayBackgroundProps) {
  return (
    <div className='fixed inset-0 bg-black/60 backdrop-blur-sm flex flex-col items-center justify-center z-30 p-4'>
      <div className='bg-transparent p-6 rounded-lg text-center max-w-xs w-full'>{children}</div>
    </div>
  )
}
